import React from "react";
import { ThemeProvider, CssBaseline, createTheme, Box } from "@mui/material";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./router/AppRoutes";

// Theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#34A936",
    },
    secondary: {
      main: "#dc004e",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: "100vh",
          background: "#000000",
        }}
      >
        <Router>
          <AppRoutes />
        </Router>
      </Box>
    </ThemeProvider>
  );
}

export default App;
